import SEO from '@/components/base/SEO';
import HeroSection from './components/HeroSection';
import CategoryNav from './components/CategoryNav';
import HotRecommend from './components/HotRecommend';
import LatestUpdate from './components/LatestUpdate';
import RankingList from './components/RankingList';
import HomeFAQ from './components/HomeFAQ';
import NewsletterSection from './components/NewsletterSection';

const homeSchema = {
  '@context': 'https://schema.org',
  '@type': 'WebSite',
  name: '樱花漫画网',
  url: 'https://yinghuacomic.com',
  description: '樱花漫画网提供全集漫画大全，漫画全集免费完整版下拉式在线阅读，涵盖好看的韩漫日漫国漫全本漫画，一次看个够。',
  potentialAction: {
    '@type': 'SearchAction',
    target: 'https://yinghuacomic.com/search?q={search_term_string}',
    'query-input': 'required name=search_term_string',
  },
};

const orgSchema = {
  '@context': 'https://schema.org',
  '@type': 'Organization',
  name: '樱花漫画网',
  url: 'https://yinghuacomic.com',
  description: '全集漫画免费在线阅读平台',
};

export default function Home() {
  return (
    <>
      <SEO
        title="樱花漫画网 - 全集漫画大全 | 漫画全集免费完整版下拉式在线阅读"
        description="樱花漫画网提供全集漫画大全，漫画全集免费完整版下拉式在线阅读，涵盖好看的韩漫日漫国漫全本漫画，一次看个够。为您精选热门韩漫、经典日漫、优质国漫，打造最佳漫画阅读体验。"
        keywords="全集漫画,漫画全集,完整版漫画,漫画全集免费,全本漫画,樱花漫画网,下拉式阅读,韩漫,日漫,国漫,好看的漫画"
        canonical="https://yinghuacomic.com"
        ogTitle="樱花漫画网 - 全集漫画大全 | 漫画全集免费完整版下拉式在线阅读"
        ogDescription="好看的韩漫日漫国漫全本漫画推荐，全集漫画免费完整版在线阅读。"
        ogType="website"
        ogUrl="https://yinghuacomic.com"
        twitterCard="summary_large_image"
        jsonLd={[homeSchema, orgSchema]}
      />

      <HeroSection />
      <CategoryNav />
      <HotRecommend />
      <LatestUpdate />
      <RankingList />
      <HomeFAQ />
      <NewsletterSection />
    </>
  );
}